import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

import user from "./user";
import courses from "./courses";
import documents from "./documents";
import forum from "./forum";
import blog from "./blog";
import marketplace from "./marketplace";
import notifications from "./notifications";
import newsletters from "./newsletters";
import search from "./search";
import tools from "./tools";
import community from "./community";

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  state,
  mutations,
  modules: {
    user,
    courses,
    documents,
    forum,
    blog,
    marketplace,
    notifications,
    newsletters,
    search,
    tools,
    community
  }
});
